import { render, staticRenderFns } from "./YoutubeEmbed.vue?vue&type=template&id=e881a60e&"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js&"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports